import { Component, OnInit } from '@angular/core';
import {CerfService} from '../../services/cerf/cerf.service';
import {Cerf} from '../../interfaces/Cerf';
import {ActivatedRoute, ParamMap} from '@angular/router';

@Component({
  selector: 'app-cerf-edit',
  templateUrl: './cerf-edit.component.html',
  styleUrls: ['./cerf-edit.component.scss']
})
export class CerfEditComponent implements OnInit {

  cerf: Cerf;
  existingFiles = [];
  cerfId?: number;

  constructor(private route: ActivatedRoute,
              private cerfService: CerfService) { }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.cerfId = Number(params.get('cerfId'));
        this.cerfService.getCerf(this.cerfId).then((res) => {
          this.existingFiles = res.existingFiles;
          this.cerf = res;
        });
    });
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/cerf/components/cerf-edit/cerf-edit.component.ts